<template>
  <div class="tareo">
    <md-progress-bar md-mode="indeterminate" v-if="loading" />
    <div class="tareo__fecha">
      <div class="tareo__employee" v-if="itemSelected.id">
        <div class="tareo__employee-title" @click="itemSelected = {}">Empleados</div>
        <div class="tareo__employee-names">{{ userSelected }}</div>
      </div>
      <v-date-picker
        v-model="dateDay"
        class="datepick"
        :formats="formats"
        popover-visibility="focus"
        @input="setDay"
        @update:frompage="evento"
      >
        <input
          type="text"
          id="dateDay"
          slot-scope="{ inputValue }"
          readonly
          :value="inputValue | formatDate"
        />
      </v-date-picker>
    </div>

    <div class="tareo__main">
      <div class="tareo__header">
        <div class="tareo__search" v-show="!itemSelected.id && !!listEmploy.length">
          <md-field>
            <md-icon class="icon-search"></md-icon>
            <md-input v-model="search" placeholder="Buscar"></md-input>
          </md-field>
        </div>
        <!-- <md-button class="md-dense md-raised md-primary btn-feriado" @click="holidays">
      Feriados
    </md-button> -->
      </div>

      <EmpTareo v-if="itemSelected.id" v-model="itemSelected" />

      <div class="tareo__body">
        <template v-if="loading">
          <div class="items-loading" v-for="n in 20" :key="n">
            <vue-content-loading
              :width="210"
              :height="40"
              primary="#f3f3f3"
              secondary="#e0e0e0"
            >
              <circle cx="20" cy="20" r="15" />
              <rect x="45" y="10" rx="4" ry="4" width="150" height="20" />
            </vue-content-loading>
          </div>
        </template>

        <template v-else-if="loading || !!listEmployComp.length">
          <SMEmploy
            v-for="(item, index) in listEmployComp"
            :key="index"
            :item="item"
            @click.native="displayEmpTareo(item)"
          />
        </template>
        <template v-else>
          <div class="nodata-content">
            <img src="../assets/img/no_data.svg" alt="" />
            <h5>No hay datos disponibles</h5>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SMEmploy from "@/components/empleado/SMEmploy";
import EmpTareo from "@/components/empleado/EmpTareo";

import VueContentLoading from "vue-content-loading";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  components: {
    SMEmploy,
    EmpTareo,
    VueContentLoading,
  },
  name: "TareoView",
  created() {
    // this.getEmployees(this.$localStorage.get('businessID'))
    // .then(r => {
    //   console.log(r)
    //   this.loading = false
    // })

    this.getDayReports({
      date: new Date().toISOString(),
      businessID: this.$localStorage.get("businessID"),
    }).then((r) => {
      if (r.status == 200) {
        this.loading = false;
        console.log(r.data);
      }
    });
  },
  data() {
    return {
      //loading data
      loading: true,
      dateDay: new Date(),
      search: null,
      formats: {
        input: "WWWW',' DD 'de' MMMM 'de' YYYY",
      },
      userSelected: "",
      itemSelected: {},
    };
  },

  computed: {
    ...mapState({
      // listEmploy: state=>state.business.dailyReportList
    }),
    ...mapGetters({
      listEmploy: "tareoReportList",
    }),
    listEmployComp() {
      if (!this.search) return this.listEmploy;
      return this.listEmploy.filter(
        (employ) =>
          employ.firstName.toUpperCase().includes(this.search.toUpperCase()) ||
          employ.firstSurname.toUpperCase().includes(this.search.toUpperCase()) ||
          employ.secondSurname.toUpperCase().includes(this.search.toUpperCase())
      );
    },
  },

  filters: {
    formatDate(value) {
      let splitStr = value.split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        if (i == 0 || i == 3)
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
  },

  methods: {
    ...mapActions({
      // getEmployees: 'getEmployees',
      getDayReports: "getEmployeesDailyReport",
    }),

    displayEmpTareo(item) {
      this.itemSelected = item;
      this.userSelected = item.firstName.split(" ")[0] + " " + item.firstSurname;
    },

    setDay(val) {
      // console.log(val)
      this.loading = true;
      this.itemSelected = {};

      this.getDayReports({
        date: val.toISOString(),
        businessID: this.$localStorage.get("businessID"),
      }).then((r) => {
        if (r.status == 200) {
          console.log("nueva fecha seteada", r.data);
          this.loading = false;
        }
      });
    },

    evento(val) {
      console.log("valor de val: ", val);
    },
    holidays() {
      console.log("en Holiday");
      this.$store.dispatch("getHolidays").then((res) => {
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss">
$b-blue: #000000;
.datepick {
  input[type="text"] {
    text-align: center;
    font-size: 16px;
    text-align: center !important;
    color: #4d4f5c;
    &::placeholder {
      color: rgba($b-blue, 0.6);
    }
  }
}
</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS

//datepicker
.datepick {
  // border-bottom: 1px solid #d7dae2;
  width: 21rem;
  border: medium none;
  border-radius: 6px;
  height: 4rem;
  background-color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  @include mq("630px") {
    margin-left: 0.25rem;
    height: 3rem;
  }
}

#dateDay {
  width: 24rem;
  cursor: default;
  user-select: none;
  @include mq($lg) {
    cursor: pointer;
  }
}

.c-weekday {
  text-transform: uppercase !important;
  font-weight: bold;
}
//vue-material
.md-field {
  width: 18rem;
  margin: 0 2rem 1.5rem 24px;
  @include mq($sm) {
    width: 100% !important;
  }

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.md-field.md-theme-default > .md-icon::after {
  background-color: #fff;
}

.tareo {
  width: 100%;
  background-color: #eceff8;
  @include mq($md) {
    min-height: 100%;
  }
  &__fecha {
    height: 9rem;
    border-bottom: 1px solid rgba($b-blue, 0.14);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    flex-direction: column;
    color: white;
    @include mq("630px") {
      height: 5rem;
      flex-direction: row-reverse;
      justify-content: flex-end;
    }
    @include mq($md) {
      justify-content: center;
      padding: 0;
    }
    @include mq("945px") {
      justify-content: flex-end;
      padding: 0 1rem;
    }
  }
  &__header {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    .btn-feriado {
      margin: auto;
    }
  }
  &__employee {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0.5rem;
    @include mq("630px") {
      margin: 0 0 0 1.5rem;
    }
    &-title {
      background-color: $b-blue;
      height: 3rem;
      line-height: 3rem;
      padding: 0 1.5rem;
      clip-path: polygon(91% 0%, 100% 50%, 91% 100%, 0% 100%, 9% 50%, 0% 0%);
      z-index: 10;
      @include mq($lg) {
        cursor: pointer;
      }
    }
    &-names {
      height: 3rem;
      // width: 3rem;
      line-height: 3rem;
      padding: 0 1.5rem 0 2rem;
      background-color: $b-emph;
      clip-path: polygon(91% 0%, 100% 50%, 91% 100%, 0% 100%, 9% 50%, 0% 0%);
      margin-left: -1.5rem;
      min-width: 6rem;
    }
  }

  &__main {
    padding: 0 1rem;
    min-height: 30rem;
    position: relative;
  }

  &__search {
    display: flex;
    justify-content: center;
    width: 21rem;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
    align-items: center;
    margin-top: 1rem;
    border-radius: 6px;
    height: 4rem;
    @include mq("630px") {
      margin-left: 0.25rem;
      margin-right: 0;
      width: 42.5rem;
    }
    @include mq($md) {
      width: 21rem;
      margin-left: auto;
      margin-right: auto;
    }
    @include mq("945px") {
      margin-left: 0.25rem;
      margin-right: 0;
      width: 42.5rem;
    }
  }

  &__body {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-top: 1rem;
    // height: 30rem;
    // position: relative;
    align-items: center;

    & > * {
      margin: 0.25rem 0;
      @include mq($sm) {
        margin: 0.25rem;
      }
    }

    @include mq("630px") {
      flex-direction: row;
    }
    @include mq($md) {
      flex-direction: column;
    }
    @include mq("945px") {
      flex-direction: row;
    }
  }
}

.items-loading {
  width: 21rem;
  height: 4rem;
  background-color: white;
  border-radius: 9px;
}
.nodata-content {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 300px;
    margin: 0 auto;
  }
  h5 {
    color: $b-emph;
    margin: 2rem auto;
    font-size: 24px;
  }
}
</style>
